import { render, staticRenderFns } from "./assigned-evaluations.vue?vue&type=template&id=1cf88dda&"
import script from "./assigned-evaluations.js?vue&type=script&lang=js&"
export * from "./assigned-evaluations.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports